import React from "react";
import "./ConsultationNote.css";

const ConsultationNote = () => {
  return (
    <section className="consultation-note-wrapper">
      <p className="consultation-note-text">
        We’ll schedule a personal consultation <br />
        to understand your business goals, <br />
        provide a demo, and walk you <br />
        through the next steps.
      </p>
    </section>
  );
};

export default ConsultationNote;
